<template>
    <div class="products_services_container" id="products_services">
        <div class="products_services_gradient_1" v-lazy:background-image="require('@/assets/static/imgs/home/icon-left-half-circle.png')">
            <div class="products_services_gradient_2" v-lazy:background-image="require('@/assets/static/imgs/home/icon-cube.png')">
                <div class="products_services_gradient_3" v-lazy:background-image="require('@/assets/static/imgs/home/icon-hexagon.png')">
                    <div class="products_services_gradient_4" v-lazy:background-image="require('@/assets/static/imgs/home/icon-right-half-circle.png')">
                        <div class="products_services_main">
                            <div class="products_services_title">{{ $t('index.products_services_title') }}</div>
                            <div class="products_services_desc">{{ $t('index.products_services_desc') }}</div>
                            <div class="products_services_item_box">
                                <div 
                                    class="products_services_item" 
                                    v-for="(item, i) in blocks" :key="i" 
                                    :style="backgroundImageStyle(i)">
                                    <p>{{ $t('index.products_services_item_title_' + i) }}</p>
                                    <p>{{ $t('index.products_services_item_desc_' + i) }}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'ProductsServicesPc',
    data() {
        return {
            tips  : 'Hello World',
            blocks: 6
        }
    },

    methods: {
        // 动态添加背景图
        backgroundImageStyle(i)
		{
			const imageUrl = require(`@/assets/static/imgs/home/icon-proservices-${i}.png`);
			return {
				'background-image'   : `url(${imageUrl})`,// 使用 require 导入图片路径
				// 'background-position': '387px center',    // 设置背景图片位置
				'background-repeat'  : 'no-repeat',       // 设置背景图片是否重复
				// 'background-size' : '212px 202px',     // 设置背景图片填充方式
			};
		}
    }
}
</script>

<style lang="less" scoped>
.products_services_container{
	display:flex;justify-content:center;align-items:flex-start;
	width:100%;height:var(--com-base-top-container-h3);
	background:linear-gradient(135deg, rgba(63, 11, 157, 1), rgba(19, 21, 77, 1), rgb(15, 17, 66), rgba(30, 4, 78, 1));
	.products_services_gradient_1{
		width:inherit;height:inherit;
		background-position:90px 110px;
		background-repeat:no-repeat;
		background-size:143px 148px;
		.products_services_gradient_2{
			width:inherit;height:inherit;
			background-position:30px 850px;
			background-repeat:no-repeat;
			background-size:212px 215px;
			.products_services_gradient_3{
				width:inherit;height:inherit;
				background-position:1600px 40px;
				background-repeat:no-repeat;
				background-size:95px 89px;
				.products_services_gradient_4{
					width:inherit;height:inherit;
					background-position:right bottom;
					background-repeat:no-repeat;
					background-size:161px 192px;
					.products_services_main{
						margin:0 auto;padding-top:75px;
						width:var(--com-base-container-w);height:inherit;
						/* background:#CCC; */
						.products_services_title{
							height:50px;line-height:50px;
							font-size:var(--com-base-fz-48);font-weight:bold;color:#FFF;text-align:center;
						}
						.products_services_desc{
							height:50px;line-height:50px;
							font-size:var(--com-base-fz-22);font-weight:normal;color:#7D7EA8;text-align:center;
						}
						.products_services_item_box{
							margin:0 auto;margin-top:30px;
							width:1250px;height:700px;
							display:flex;justify-content:space-between;align-items:center;flex-wrap:wrap;
							.products_services_item{
								width:600px;height:200px;
								border:2px solid rgba(255, 255, 255, .1);border-radius:24px;
								padding:24px;
								background-position:387px center;
								background-size:212px 202px;
								p:nth-child(1){
									font-family:var(--com-number-coin-fm-M);font-size:var(--com-base-fz-22);color:#FFF;
								}
								p:nth-child(2){
									font-family:var(--com-number-coin-fm-L);font-size:var(--com-base-fz-18);font-weight:normal;color:#BABFEC;
									line-height:1.5;
									margin-top:15px;
								}
							}
						}
					}
				}
			}
		}
	}
}
</style>